import { useI18n, CURRENCIES } from '@/i18n';

export default function CurrencySelector({ className = '' }) {
  const { currency, setCurrency } = useI18n();

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="currency-selector">
      {CURRENCIES.map((c) => (
        <button
          key={c.code}
          onClick={() => setCurrency(c.code)}
          className={`px-2 py-1 rounded text-xs font-medium transition-all ${
            currency === c.code
              ? 'bg-[#264639] text-white shadow-sm'
              : 'text-[#78716C] hover:bg-[#F5F4F0]'
          }`}
          data-testid={`currency-${c.code}`}
          title={c.label}
        >
          {c.symbol}
        </button>
      ))}
    </div>
  );
}
